<!-- eslint-disable vue/no-lone-template -->
<!-- eslint-disable vue/no-v-html -->
<template>
    <ui-modal
        name="message-modal"
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad"
        size="xs">
        <div class="modal-content">
            <template>
                <div class="content">
                    <ui-media v-if="content.media_url" :url-media="content.media_url" :type="content.media_type" :text="content.text" :link="content.cover_link" :target="content.target" autoPlay/>
                    <div class="text">
                        <div v-html="content.title" />
                        <div v-html="content.subtitle" />
                    </div>
                </div>
            </template>
        </div>

        <template #footer>
            <div class="hide-me">&nbsp</div>
            <div class="footer-message-modal">
                <ui-checkbox
                    id="not-show-again"
                    label="Não mostrar novamente"
                    name="not-show-again"
                    @input="notShowAgain" />
                <ui-button @click="closeModal"> Fechar </ui-button>
            </div>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiButton } from '@/components/ui/buttons'
    import { uiCheckbox } from '@/components/ui/form'
    import { uiMedia } from '@/components/ui'
    import { storage } from '@/services/storage'
    import { s3Filesystem } from '@/services/axios'

    const moment = require('moment')
	require('moment/locale/pt-br')

    const user = JSON.parse(storage.get('user_logged'))
    const instance = storage.get('api_config') ? JSON.parse(storage.get('api_config')).instance : ''
    const notShowModals = JSON.parse(storage.get('not_show_modals'))
    export default {
        name: 'ui-message-modal',
        components: {
            uiModal,
            uiCheckbox,
            uiButton,
            uiMedia
        },
        props: {
            setRoute: {
                type: String,
                default: null
            },
            v2: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                loader: {
                    modalLoad: false,
                    modalLoadSuccess: false,
                    taskTypeLoad: false,
                },
				newsModal: JSON.parse(storage.get('news-modal')),
                content: {
                    id: '',
                    title: 'Mensagem',
                    subtitle: 'Vídeo',
                    video_url: '',
                    text: 'Este modal contém um vídeo experimental',
                    link_text: 'Acesse o link',
                    media_url: '',
                    media_type: '',
                    position: '',
                    start_time: '',
                    end_time: '',
                    instances: '',
                    user_role: '',
                    route: ''
                }
            }
        },
        computed: {
            dataBusiness() {
				let configs = JSON.parse(storage.get('get-configs-data'))
				return configs.dataBusiness
			}
        },

        mounted() {
            this.loadContent()
            this.$root.$on('modal-close-message-modal', () => {
                const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
            })
        },
        beforeDestroy() {
            this.$root.$off('modal-close-message-modal')
        },

        methods: {
            /**
             * Carrega o conteúdo a ser mostrado no modal de mensagem e abre o modal
             */
            loadContent() {
                //const analiseTimeModal = this.newsModal ? this.analiseTime(moment(), moment(this.newsModal.time)) : null
				return this.newsModal ? this.getStorage() : this.getApi()
            },
            getApi() {
				s3Filesystem.getNewsModal()
				.then(response => {
					storage.set('news-modal', JSON.stringify({ time: moment(), items: response.data }))
					this.newsModal = { time: moment(), items: response.data }
					this.setMessage(response.data)
				})
				.catch(error => {
					console.error(error)
				})
            },
			getStorage() {
				return this.analiseTime(moment(), moment(this.newsModal.time)) < 30 ? this.setMessage(this.newsModal.items) : this.getApi()
			},
            setMessage(response) {
                const route = this.setRoute ? this.setRoute : this.$route.path
                const messages = [...response.items || []] 
                    const filterMessages = messages.filter(res => {
                        return this.filterv2(res.v2)
                    })
                    const message = this.getMatchedMessage(filterMessages, route)
                    if (message && (!notShowModals || !notShowModals.includes(message.id))) {
                        this.content = { ...message }
                        this.$root.$emit('modal-open-message-modal')
                    }
            },
            analiseTime(now, before) {
                return now.diff(before, 'minutes')
            },

            
            /**
             * Filtra as mensagens e acordo com os criterios das regras de negócio
             * e retorna a que da match em todos os critérios
             */
            getMatchedMessage(a, route) {
                const getStorage = JSON.parse(storage.get('api_config'))
                const instance = getStorage.instance

                let exist = a.filter(item => {
                    /**
                     * Verifica se a rota configurada na mensagem é 
                     * a mesma em que o usuario está navegando
                     */
                    const routeMatch = item.route === route
                    /**
                     * Verifica se a data atual está entre o  start_time e  end_time 
                     * configurados para a mensagem
                     */
                    const currentTime = moment()
                    const startTime = moment(item.start_time, 'DD/MM/YYYY HH:mm A')
                    const endTime = moment(item.end_time, 'DD/MM/YYYY HH:mm A')
                    const timeMatch = currentTime.isSameOrAfter(startTime) && currentTime.isSameOrBefore(endTime)

                    /**
                     * Verifica se a instância atual está entre as configuradas e/ou se a mensagem está 
                     * configurada para todas as instancias ('all')
                     */

                    const instanceMatch = item.instances.includes(instance) || item.instances.includes('all')

                    /**
                     * Verifica se o(s) plano(s) contratado(s) pela instância estão entre os configurados e/ou se a mensagem está 
                     * configurada para todas os planos ('all')
                     */
                    const planMatch = item.flat.includes(this.dataBusiness.plano) || item.flat.includes('all')

                    /**
                     * Verifica se o segmento cadastradona instancia está entre os 
                     * configurados e/ou se a mensagem está configurada para todos os segmentos ('all')
                     */
                    const segmentMatch = item.segment.includes(this.dataBusiness.segmento) || item.segment.includes('all')

                    /**
                     * Verifica se a(s) permissão(ões) de grupo de usuário do usuário logado está entre os
                     * configurados e/ou se a mensagem está configurada para
                     * todas as permissões de grupo de usuário ('all')
                     */
                    const userRoleMatch = item.user_role.includes(user.user_group) ||  item.user_role.includes('all')
                    
                    /** 
                     * Retorna a permissão para renderizar o modal se todos os critérios 
                     * da regra de negócio estiverem corretos
                     */

                    return routeMatch && timeMatch && instanceMatch && planMatch && segmentMatch && userRoleMatch
                })

               /**
                * Se houver mais de uma mensagem filtrada com todos os critérios, retorna a ultima(mais recente)
                */
                const result = exist.length ? exist.pop() : null

                return result
            },

            filterv2(item) {
                if(this.v2) {
                    return item == true
                }
                else {
                    return item == false
                }
            },
            /**
             * Realiza uma configuração no localStorage para não mais mostrar o modal atual
             */
            notShowAgain() {
                let notShowModalsUpdated = notShowModals || []
                notShowModalsUpdated.push(this.content.id)
                storage.set('not_show_modals', JSON.stringify(notShowModalsUpdated))
            },
            closeModal() {
                this.$root.$emit('modal-close-message-modal')
                const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
                this.$root.$emit('pause-video')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>